import { useCallback, useState } from 'react';

/**
 * A convenience hook for boolean state toggling.
 *
 * @param initial Initial value (default: false)
 * @returns [value, toggleFn, setFn]
 */
export function useToggle(
  initial = false,
): [boolean, () => void, (v: boolean) => void] {
  const [value, setValue] = useState(initial);
  const toggle = useCallback(() => setValue((v) => !v), []);
  return [value, toggle, setValue];
}
